import * as React from 'react'

const ChatButton = ({ children, customClass }) => {
  return (
    <div
      className={`${customClass}`}
      onClick={() => {
        if (typeof window !== 'undefined') {
          window.tidioChatApi.show()
          window.tidioChatApi.open()
        }
      }}
    >
      {children}
    </div>
  )
}

export default ChatButton
